<template>
  <div class="bb-refund-handover-form-wrapper">
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
    <div class="bb-refund-handover-form"
         :class="{'bb-refund-handover-form_hide': proformaRefund}"
         id="bb-refund-handover-form-pdf"
    >
      <div class="bb-refund-handover-form__padding
                  bb-refund-handover-form__padding_top"
           :class="{'bb-refund-handover-form__padding_top_pdf': hideForPdf}"/>
      <div class="bb-refund-handover-form-header">
        <div class="bb-refund-handover-form-header__date">
          <div v-if="hideForPdf" class="bb-refund-handover-form-header__data-text">{{formatDate}}</div>
          <DataPicker :default-date="date"
                      @setDate="setDate"
                      :format="'MMM DD, YYYY'" v-else/>
        </div>
        <div class="bb-refund-handover-form-header-client"
             :class="{'bb-refund-handover-form-header-client_hide': hideForPdf}"
        >
          <div :contenteditable="issuedToEditable"
               @input="onInputIssued"
               v-autofocus
               class="bb-refund-handover-form-header-client__name"
               :class="{
                 'bb-refund-handover-form-header-client__name_border': issuedToEditable,
                 'bb-refund-handover-form-header-client__name_border-transparent': hideForPdf
               }"
               id="client-name"
          >
            <pre>{{issuedTo}}</pre>
          </div>
          <i v-if="!hideForPdf"
             @click.stop="issuedOpenEdit(true)"
             class="icon-edit bb-icon bb-icon_accent bb-refund-handover-form-header__icon"/>
        </div>
        <div class="bb-refund-handover-form-header-info
                    bb-refund-handover-form-header-info_pdf"
             v-if="hideForPdf"
        >
          {{addressClient}}
        </div>
        <div v-else-if="openTextarea && !hideForPdf"
             class="bb-refund-handover-form-header-info"
        >
          <textarea class="bb-input
                           bb-input_border
                           bb-refund-handover-form-header-info__textarea"
                    v-model="addressClient"
          ></textarea>
        </div>
      </div>
      <h2 class="bb-refund-handover-form-title">
        Subject: REFUND re. {{taxInvoiceNum}}
      </h2>
      <div class="bb-refund-handover-form-confirm">
        <p class="bb-refund-handover-form-confirm__paragraph"
           :class="{'bb-refund-handover-form-confirm__paragraph_block': hideForPdf}"
        >
          <span>Dear Business Boutique DMCC,</span>
        </p>
        <p class="bb-refund-handover-form-confirm__paragraph"
           :class="{'bb-refund-handover-form-confirm__paragraph_block': hideForPdf}"
        >
          <span>Greetings!</span>
        </p>
        <p class="bb-refund-handover-form-confirm__paragraph"
           :class="{'bb-refund-handover-form-confirm__paragraph_inline': hideForPdf}"
        >
          <span class="bb-refund-handover-form-confirm__text">
            I would like to request for a refund amounting to AED
          </span>
          <span v-if="hideForPdf">{{numeralConvertNumber(refundSum)}}.</span>
          <label class="bb-refund-handover-form-label
                        bb-bb-refund-handover-form-label_confirm"
                 v-else
          >
            <span>{{space}}</span>
            <input class="bb-input
                          bb-input_border
                          bb-input_border_dark
                          bb-refund-handover-form-confirm-input
                          bb-refund-handover-form-confirm-input_client"
                   :class="{'bb-input_error': errors.refundSum}"
                   @focus="clearError('refundSum')"
                   v-model="refundSum"
                   type="text">
            <span>.{{space}}</span>
          </label>
          <span>Kindly arrange for the</span>
        </p>
        <p class="bb-refund-handover-form-confirm__paragraph"
           :class="{'bb-refund-handover-form-confirm__paragraph_inline': hideForPdf}"
        >
          <span>payment of the said refund through</span>
          <span v-if="hideForPdf">{{payment.name}}.</span>
          <span class="bb-refund-handover-form-confirm-input
                       bb-refund-handover-form-confirm__select"
                v-else
          >
            <BBSelect :options="typePayment.list"
                      :error="errors[typePayment.model]"
                      :clearable="typePayment.clearable"
                      :label="typePayment.labelList"
                      :value="payment"
                      :placeholder="typePayment.placeholder"
                      @dropdownOpen="clearError('payment')"
                      @change="setPayment"/>
          </span>
          <span v-if="!hideForPdf">.{{space}}</span>
          <span>Below are the necessary details:</span>
        </p>
        <transition name="slide-select">
          <div v-if="payment.id === 1"
               :class="{'bb-refund-handover-form-confirm__payment': hideForPdf}"
          >
            <p class="bb-refund-handover-form-confirm__paragraph"
               :class="{'bb-refund-handover-form-confirm__paragraph_block': hideForPdf}"
            >
              <span class="bb-refund-handover-form-row">
                <span class="bb-refund-handover-form-row__item">Name of the receiver</span>
                <span v-if="hideForPdf">{{receiverName}}</span>
                <label v-else
                       class="bb-refund-handover-form-label
                              bb-bb-refund-handover-form-label_confirm"
                >
                  <input class="bb-input
                                bb-input_border
                                bb-input_border_dark
                                bb-refund-handover-form-confirm-input
                                bb-refund-handover-form-confirm-input_client"
                         :class="{'bb-input_error': errors.receiverName}"
                         @focus="clearError('receiverName')"
                         v-model="receiverName"
                         type="text">
                </label>
              </span>
            </p>
            <p class="bb-refund-handover-form-confirm__paragraph"
               :class="{'bb-refund-handover-form-confirm__paragraph_block': hideForPdf}"
            >
              <span class="bb-refund-handover-form-row">
                <span class="bb-refund-handover-form-row__item">Contact number</span>
                <span v-if="hideForPdf">{{contactNumber}}</span>
                <label v-else class="bb-refund-handover-form-label
                            bb-bb-refund-handover-form-label_confirm"
                >
                  <input class="bb-input
                              bb-input_border
                              bb-input_border_dark
                              bb-refund-handover-form-confirm-input
                              bb-refund-handover-form-confirm-input_client"
                         :class="{'bb-input_error': errors.contactNumber}"
                         @focus="clearError('contactNumber')"
                         v-model="contactNumber"
                         type="text">
                  </label>
              </span>
            </p>
            <p class="bb-refund-handover-form-confirm__paragraph"
               :class="{'bb-refund-handover-form-confirm__paragraph_block': hideForPdf}"
            >
              <span class="bb-refund-handover-form-row
                           bb-refund-handover-form-row_gap"
                    :class="{'bb-refund-handover-form-row_pdf': hideForPdf}">
                <span class="bb-refund-handover-form-row__item"
                      :class="{'bb-refund-handover-form-row_item-pdf': hideForPdf}"
                >
                  ID number
                </span>
                <span v-if="hideForPdf">{{idNumber.name}}</span>
                <span v-else class="bb-refund-handover-form-confirm-input
                                    bb-refund-handover-form-confirm__flex"
                >
                  <BBSelect :options="typeNumber.list"
                            :error="errors[typeNumber.model]"
                            :clearable="typeNumber.clearable"
                            :label="typeNumber.labelList"
                            :value="idNumber"
                            :placeholder="typeNumber.placeholder"
                            @change="setNumber"/>
                  <span>,</span>
                  <input v-if="!hideForPdf" class="bb-input
                                bb-input_border
                                bb-input_border_dark
                                bb-refund-handover-form-confirm-input
                                bb-refund-handover-form-confirm-input_number"
                         @focus="clearError('idNumberDescription')"
                         type="text"
                         v-model="idNumberDescription"
                         :class="{'bb-input_error': errors.idNumberDescription}">
                </span>
                <span v-if="hideForPdf">{{idNumberDescription}}</span>
              </span>
            </p>
          </div>
          <div v-if="payment.id === 2 || payment.id === 3"
               :class="{'bb-refund-handover-form-confirm__payment': hideForPdf}"
          >
            <p class="bb-refund-handover-form-confirm__paragraph"
               :class="{'bb-refund-handover-form-confirm__paragraph_block': hideForPdf}"
            >
              <span class="bb-refund-handover-form-row">
                <span class="bb-refund-handover-form-row__item">Name of Bank</span>
                <span v-if="hideForPdf">{{bankName}}</span>
                <label v-else class="bb-refund-handover-form-label
                                     bb-bb-refund-handover-form-label_confirm"
                >
                  <input class="bb-input
                                bb-input_border
                                bb-input_border_dark
                                bb-refund-handover-form-confirm-input
                                bb-refund-handover-form-confirm-input_client"
                         :class="{'bb-input_error': errors.bankName}"
                         @focus="clearError('bankName')"
                         v-model="bankName"
                         type="text">
                </label>
              </span>
            </p>
            <p class="bb-refund-handover-form-confirm__paragraph"
               :class="{'bb-refund-handover-form-confirm__paragraph_block': hideForPdf}"
            >
              <span class="bb-refund-handover-form-row">
                <span class="bb-refund-handover-form-row__item">Account Name</span>
                <span v-if="hideForPdf">{{accountName}}</span>
                <label v-else class="bb-refund-handover-form-label
                                     bb-bb-refund-handover-form-label_confirm"
                >
                  <input class="bb-input
                                bb-input_border
                                bb-input_border_dark
                                bb-refund-handover-form-confirm-input
                                bb-refund-handover-form-confirm-input_client"
                         :class="{'bb-input_error': errors.accountName}"
                         @focus="clearError('accountName')"
                         v-model="accountName"
                         type="text">
                </label>
              </span>
            </p>
            <p class="bb-refund-handover-form-confirm__paragraph"
               :class="{'bb-refund-handover-form-confirm__paragraph_block': hideForPdf}"
            >
              <span class="bb-refund-handover-form-row">
                <span class="bb-refund-handover-form-row__item">Account Number</span>
                <span v-if="hideForPdf">{{accountNumber}}</span>
                <label v-else class="bb-refund-handover-form-label
                                     bb-bb-refund-handover-form-label_confirm"
                >
                  <input class="bb-input
                                bb-input_border
                                bb-input_border_dark
                                bb-refund-handover-form-confirm-input
                                bb-refund-handover-form-confirm-input_client"
                         :class="{'bb-input_error': errors.accountNumber}"
                         @focus="clearError('accountNumber')"
                         v-model="accountNumber"
                         type="text">
                </label>
              </span>
            </p>
            <template v-if="payment.id === 3">
              <p class="bb-refund-handover-form-confirm__paragraph"
                 :class="{'bb-refund-handover-form-confirm__paragraph_block': hideForPdf}"
              >
                <span class="bb-refund-handover-form-row">
                  <span class="bb-refund-handover-form-row__item">IBAN</span>
                  <span v-if="hideForPdf">{{iban}}</span>
                  <label v-else class="bb-refund-handover-form-label
                                       bb-bb-refund-handover-form-label_confirm"
                  >
                    <input class="bb-input
                                  bb-input_border
                                  bb-input_border_dark
                                  bb-refund-handover-form-confirm-input
                                  bb-refund-handover-form-confirm-input_client"
                           :class="{'bb-input_error': errors.iban}"
                           @focus="clearError('iban')"
                           v-model="iban"
                           type="text">
                  </label>
                </span>
              </p>
              <p class="bb-refund-handover-form-confirm__paragraph"
                 :class="{'bb-refund-handover-form-confirm__paragraph_block': hideForPdf}"
              >
                <span class="bb-refund-handover-form-row">
                  <span class="bb-refund-handover-form-row__item">Bank address</span>
                   <span v-if="hideForPdf">{{bankAddress}}</span>
                    <label v-else class="bb-refund-handover-form-label
                                         bb-bb-refund-handover-form-label_confirm"
                    >
                      <textarea class="bb-input
                                       bb-input_border
                                       bb-input_border_dark
                                       bb-refund-handover-form-confirm-input
                                       bb-refund-handover-form-confirm-input_bank"
                                :class="{'bb-input_error': errors.bankAddress}"
                                @focus="clearError('bankAddress')"
                                v-model="bankAddress"
                      />
                    </label>
                </span>
              </p>
              <p class="bb-refund-handover-form-confirm__paragraph"
                 :class="{'bb-refund-handover-form-confirm__paragraph_block': hideForPdf}"
              >
                <span class="bb-refund-handover-form-row">
                  <span class="bb-refund-handover-form-row__item">Swift Code</span>
                  <span v-if="hideForPdf">{{swiftCode}}</span>
                  <label v-else class="bb-refund-handover-form-label
                                       bb-bb-refund-handover-form-label_confirm"
                  >
                    <input class="bb-input
                                  bb-input_border
                                  bb-input_border_dark
                                  bb-refund-handover-form-confirm-input
                                  bb-refund-handover-form-confirm-input_client"
                           :class="{'bb-input_error': errors.swiftCode}"
                           @focus="clearError('swiftCode')"
                           v-model="swiftCode"
                           type="text">
                  </label>
                </span>
              </p>
            </template>
          </div>
        </transition>
        <p class="bb-refund-handover-form-confirm__paragraph
                  bb-refund-handover-form-confirm__paragraph_padding"
           :class="{'bb-refund-handover-form-confirm__paragraph_block': hideForPdf}"
        >
          <span>Regards,</span>
        </p>
      </div>
      <div class="bb-refund-handover-form-sign">
        <div class="bb-refund-handover-form-sign-item">
          <span v-if="hideForPdf">{{client}}</span>
          <label v-else
                 class="bb-refund-handover-form-label"
          >
            <input class="bb-input
                          bb-input_border
                          bb-input_border_dark
                          bb-refund-handover-form-sign-item__input"
                   :class="{'bb-input_error': errors.client}"
                   @focus="clearError('client')"
                   v-model="client"
                   type="text">
          </label>
        </div>
      </div>
      <div class="bb-refund-handover-form-bottom">
        <button class="bb-button bb-refund-handover-form-bottom__button"
                v-if="!hideForPdf"
                @click="validateForm"
        >
          SAVE
        </button>
      </div>
      <div class="bb-refund-handover-form__padding
                  bb-refund-handover-form__padding_bot"/>
    </div>
  </div>
</template>

<script>
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import moment from 'moment'
import '@/assets/fonts/fontsPdf/ArialBold-bold'
import '@/assets/fonts/fontsPdf/ArialRegular-normal'
import {handoverFooter} from '@/constants/handover'
import BBSelect from '@/components/Main/Inputs/BBSelect'
import DataPicker from '@/components/Main/DataPicker/DataPicker'
import convertNumber from '@/mixin/convertNumber'
import JsPdf from 'jspdf'
import {every, cloneDeep, get} from 'lodash'
import SoaRefundApi from '@/api/SoaRefund/api'
export default {
  name: 'RefundHandoverForm',
  props: ['selectedDocuments', 'type', 'refund'],
  mixins: [convertNumber],
  components: {
    LoaderFly,
    BBSelect,
    DataPicker
  },
  data () {
    return {
      loaderRun: false,
      date: new Date(),
      openTextarea: false,
      editMode: false,
      space: String.fromCharCode(160),
      hideForPdf: false,
      payment: {},
      idNumber: {},
      refundSum: 0,
      taxInvoiceNum: '',
      documents: [],
      issuedTo: false,
      issuedToEditable: false,
      issuedToChange: false,
      proformaRefund: false,
      errors: {
        refundSum: false,
        payment: false,
        receiverName: false,
        contactNumber: false,
        idNumber: false,
        bankName: false,
        accountName: false,
        accountNumber: false,
        iban: false,
        client: false,
        idNumberDescription: false,
        bankAddress: false,
        swiftCode: false
      },
      typePayment: {
        id: 'payment',
        model: 'payment',
        list: [
          {
            id: 1,
            name: 'cash'
          },
          {
            id: 2,
            name: 'cash deposit'
          },
          {
            id: 3,
            name: 'bank transfer'
          }
        ],
        labelList: 'name',
        clearable: false,
        searchable: false,
        require: true
      },
      typeNumber: {
        id: 'idNumber',
        model: 'idNumber',
        list: [
          {
            id: 1,
            name: 'EID'
          },
          {
            id: 2,
            name: 'Passport'
          },
          {
            id: 3,
            name: 'Equivalent'
          }
        ],
        labelList: 'name',
        clearable: false,
        searchable: false,
        require: true
      },
      receiverName: '',
      client: '',
      contactNumber: '',
      bankName: '',
      accountName: '',
      accountNumber: '',
      iban: '',
      bankAddress: '',
      idNumberDescription: '',
      addressClient: '',
      nameForPdf: 'Refund',
      swiftCode: '',
      uploadFile: [],
      footerDetails: handoverFooter
    }
  },
  computed: {
    formatDate () {
      return moment(this.date).format('MMM DD, YYYY')
    },
    clientInfo: {
      get: function () {
        return this.$store.getters.clientInfo
      },
      set: function (data) {
        this.$store.dispatch('setClientInfo', data)
      }
    },
    soaCreditNotesId: {
      get: function () {
        return this.documents.map(item => {
          const id = get(item, '_id', '')
          return get(item, 'id', id)
        })
      }
    }
  },
  methods: {
    setPayment (item) {
      this.payment = item
    },
    setNumber (item) {
      this.idNumber = item
    },
    setDate (date) {
      this.date = date
    },
    clearError (model) {
      this.errors[model] = false
    },
    onInputIssued (e) {
      this.issuedToChange = e.target.innerText
    },
    setIssueTo () {
      const client = `${this.clientInfo.firstName} ${this.clientInfo.lastName}`
      this.issuedTo = get(this.refund, 'clientName', client)
      this.issuedToChange = this.issuedTo
    },
    issuedOpenEdit (data) {
      this.openTextarea = true
      this.issuedToEditable = !!data
      const div = document.getElementById('client-name')
      setTimeout(() => {
        if (div[0]) div[0].focus()
      }, 0)
    },
    generateRefundHandover () {
      const balance = this.refundSum.replace(/,/g, '')
      const refund = {
        client: this.clientInfo.id,
        clientName: this.issuedToChange,
        label: 'refund ' + this.formatDate,
        date: this.date,
        uploadFile: [],
        soaCreditNotes: this.soaCreditNotesId,
        paymentType: this.payment.id,
        balance: Number(balance)
      }
      if (this.payment.id === 1) {
        this.$set(refund, 'nameOfReceiver', this.receiverName)
        this.$set(refund, 'contactNumber', this.contactNumber)
        this.$set(refund, 'idNumber', this.idNumber.id)
        this.$set(refund, 'idNumberDescription', this.idNumberDescription)
      } else if (this.payment.id === 2) {
        this.$set(refund, 'nameOfBank', this.bankName)
        this.$set(refund, 'accountName', this.accountName)
        this.$set(refund, 'accountNumber', this.accountNumber)
      } else if (this.payment.id === 3) {
        this.$set(refund, 'nameOfBank', this.bankName)
        this.$set(refund, 'accountName', this.accountName)
        this.$set(refund, 'accountNumber', this.accountNumber)
        this.$set(refund, 'IBAN', this.iban)
        this.$set(refund, 'bankAddress', this.bankAddress)
        this.$set(refund, 'swiftCode', this.swiftCode)
      }
      return refund
    },
    validateForm () {
      let errors = {
        refundSum: this.refundSum ? false : 'mandatory field',
        payment: this.payment.id ? false : 'mandatory field'
      }
      if (this.payment.id === 1) {
        errors = {
          refundSum: this.refundSum ? false : 'mandatory field',
          receiverName: this.receiverName ? false : 'mandatory field',
          contactNumber: this.receiverName ? false : 'mandatory field',
          idNumber: this.idNumber.id ? false : 'mandatory field',
          idNumberDescription: this.idNumberDescription ? false : ''
        }
      }
      if (this.payment.id === 2) {
        errors = {
          refundSum: this.refundSum ? false : 'mandatory field',
          bankName: this.bankName ? false : 'mandatory field',
          accountName: this.accountName ? false : 'mandatory field',
          accountNumber: this.accountNumber ? false : 'mandatory field'
        }
      }
      if (this.payment.id === 3) {
        errors = {
          refundSum: this.refundSum ? false : 'mandatory field',
          bankName: this.bankName ? false : 'mandatory field',
          accountName: this.accountName ? false : 'mandatory field',
          accountNumber: this.accountNumber ? false : 'mandatory field',
          iban: this.iban ? false : 'mandatory field',
          bankAddress: this.bankAddress ? false : 'mandatory field',
          swiftCode: this.swiftCode ? false : 'mandatory field'
        }
      }
      this.errors = errors
      const success = every(this.errors, (item) => item === false)
      if (success) {
        const refundHandover = this.generateRefundHandover()
        this.editMode ? this.updateRefundHandOver(refundHandover) : this.createRefundHandOver(refundHandover)
      }
    },

    calcMaxHeightA4 () {
      let dpi = document.createElement('div')
      dpi.style.width = '1cm'
      dpi.style.height = '1cm'
      dpi.style.position = 'fixed'
      dpi.style.top = '-100%'
      dpi.style.left = '-100%'
      dpi.style.zIndex = '-1'
      document.body.appendChild(dpi)
      const result = 27 * dpi.clientHeight
      dpi.remove()
      return result
    },
    prepareHandoverNode () {
      const contentHtml = document.getElementById('bb-refund-handover-form-pdf').cloneNode(true)
      contentHtml.style.position = 'fixed'
      contentHtml.style.top = '0'
      contentHtml.style.left = '0'
      contentHtml.style.padding = '1.5cm'
      contentHtml.style.width = '19cm'
      contentHtml.style.zIndex = -1
      contentHtml.style.transform = 'scale(0.85)'
      contentHtml.style.transformOrigin = 'top center'
      contentHtml.style.backgroundColor = '#FFFFFF'
      document.body.appendChild(contentHtml)
      return contentHtml
    },
    calcHeightPdf (elem) {
      const maxHeightA4 = this.calcMaxHeightA4()
      let realHeight = elem.clientHeight
      if (elem.clientHeight > maxHeightA4) {
        let i = 85
        while (i > 2 && (elem.clientHeight * (i * 0.01)) > maxHeightA4) {
          elem.style.transform = `scale(0.${i})`
          i--
        }
      }
      return realHeight
    },
    createRefundHandOver (refundHandover) {
      this.loaderRun = true
      this.proformaRefund = true
      SoaRefundApi.createRefund(refundHandover)
        .then(() => {
          this.hideForPdf = true
          this.$nextTick(this.generatePfd)
          this.$emit('create')
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    updateRefundHandOver (refundHandover) {
      refundHandover.id = this.refund.id
      refundHandover.uploadFile = this.uploadFile.map(item => item.id)
      this.loaderRun = true
      this.proformaRefund = true
      SoaRefundApi.updateRefund(refundHandover)
        .then(() => {
          this.$emit('update')
          this.hideForPdf = true
          this.$nextTick(this.generatePfd)
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    async generatePfd () {
      const contentHtml = await this.prepareHandoverNode()
      this.hideForPdf = false
      const fileName = this.nameForPdf + '.pdf'
      const convertPdf = {
        orientation: 'p',
        unit: 'pt',
        format: 'a4',
        putOnlyUsedFonts: true,
        compress: true,
        filters: ['ASCIIHexEncode']
      }
      const doc = new JsPdf(convertPdf)
      doc.html(contentHtml, {
        callback: (pdf) => {
          pdf.deletePage(2)
          pdf.save(fileName)
          contentHtml.remove()
          this.loaderRun = false
          this.$emit('close', true)
        },
        x: -60
      })
    },
    setValuesEditRefund () {
      this.editMode = true
      this.nameForPdf = get(this.refund, 'label', 'Refund')
      const paymentId = get(this.refund, 'paymentType', 0)
      const numberId = get(this.refund, 'idNumber', 0)
      this.payment = this.typePayment.list.find(item => item.id === paymentId)
      this.receiverName = get(this.refund, 'nameOfReceiver', '')
      this.contactNumber = get(this.refund, 'contactNumber', '')
      this.idNumberDescription = get(this.refund, 'idNumberDescription', '')
      this.idNumber = this.typeNumber.list.find(item => item.id === numberId)
      this.bankName = get(this.refund, 'nameOfBank', '')
      this.accountName = get(this.refund, 'accountName', '')
      this.accountNumber = get(this.refund, 'accountNumber', '')
      this.iban = get(this.refund, 'IBAN', '')
      this.bankAddress = get(this.refund, 'bankAddress', '')
      this.swiftCode = get(this.refund, 'swiftCode', '')
      const balance = get(this.refund, 'balance', '')
      this.refundSum = this.numeralConvertNumber(balance)
      this.uploadFile = get(this.refund, 'uploadFile', [])
      this.date = get(this.refund, 'date', new Date())
      this.addressClient = get(this.refund, 'clientAddress', '')
      this.openTextarea = !!this.addressClient
    }
  },
  beforeMount () {
    this.documents = cloneDeep(this.selectedDocuments)
    const sum = this.documents.reduce((sum, item) => {
      sum += item.balance
      return sum
    }, 0)
    this.refundSum = this.numeralConvertNumber(sum)
    this.taxInvoiceNum = this.documents.reduce((number, item) => {
      const str = item.description
      const newStr = str.concat(' & ')
      number += newStr
      return number
    }, '').replace(/ & $/gmi, '')
    this.setIssueTo()
    if (this.refund) this.setValuesEditRefund()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../../sass/variables";
  @import "../../../../../../../sass/mixins";

  .bb-refund-handover-form-wrapper {
    margin: auto;
    min-width: 100%;
  }

  .bb-refund-handover-form {
    @include global-font;
    padding: 0 35px;
    width: 711px;
    position: relative;

    &-header {
      padding-bottom: 56px;

      &__data-text {
        font-size: 14px;
      }

      &__icon {
        font-size: 21px;
        margin-left: 15px;
        border-radius: 50%;
        width: 21px;
        height: 21px;
        cursor: pointer;
        user-select: none;
      }

      &__text {
        margin-right: 10px;
        font-weight: bold;
        font-size: 20px;
      }

      &-info {
        margin-top: 15px;

        &_pdf {
          font-size: 13px;
        }

        &__textarea {
          resize: none;
          font-size: 13px;
          height: 50px;
        }
      }

      &-client {
        position: relative;
        width: 100%;
        padding-top: 14px;
        display: flex;
        padding-left: 5px;

        &_hide {
          padding-left: 0;
        }

        &__name {
          margin-bottom: 7px;
          height: auto;
          line-height: 26px;
          border: 1px solid transparent;

          &_border {
            border: 1px solid $color-wild-sand;
            box-sizing: border-box;
            border-radius: 5px;
          }

          &_border-transparent {
            border: 1px solid transparent;
          }

          pre {
            white-space: pre-line;
            font-size: 14px;
            line-height: 17px;
          }
        }
      }
    }

    &-title {
      text-transform: uppercase;
      font-weight: 600;
      font-size: 14px;
      line-height: 151.34%;
      margin-bottom: 10px;
      text-align: center;
      padding-bottom: 28px;
    }

    &-row {
      display: grid;
      grid-template-columns: 180px 216px;
      grid-gap: 22px;
      align-items: center;

      &_gap {
        grid-gap: 15px;
      }

      &_pdf {
        display: inline-flex;
        justify-content: space-between;
        align-items: center;
      }

      &_item-pdf {
        padding-right: 123px;
      }

      &__item {
        font-weight: 600;
        font-size: 13px;
        line-height: 16px;
      }
    }

    &-label {
      position: relative;
      display: flex;
      align-items: center;

      &_confirm {
        margin: 0 8px;

        &_start-line {
          margin-left: 0;
        }
      }

      &__error {
        position: absolute;
        right: 12px;
        color: $color-red-orange;
        font-size: 11px;
        line-height: 13px;
      }
    }

    &-confirm {
      font-weight: normal;
      font-size: 14px;
      line-height: 17px;

      &__select {
        display: inline-block;
        position: relative;
        width: 135px;
        height: 30px;
      }

      &__payment {
        margin-top: 20px;
      }

      &__flex {
        display: flex;
        align-items: center;
        height: 30px;
        width: 215px;
      }

      &__paragraph {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-bottom: 16px;

        &_padding {
          padding-top: 28px;
          padding-bottom: 42px;
        }

        &_block {
          line-height: 20px;
          display: block;
        }

        &_inline {
          line-height: 20px;
          display: inline;
        }
      }

      &-input {
        font-weight: normal;
        font-size: 13px;
        margin-left: 8px;

        &_client {
          margin: 0;
          width: 150px;
        }

        &_number {
          margin-left: 10px;
          width: 100px;
        }

        &_bank {
          margin: 0;
          padding: 7px 10px;
          width: 180px;
          height: 57px;
        }

        &_country {
          width: 100px;
        }

        &_passport {
          width: 130px;
        }
      }
    }

    &__padding {
      position: sticky;
      width: 100%;
      background-color: $color-white;
      height: 20px;

      &_top {
        top: 0;
        height: 55px;

        &_pdf {
          height: 35px;
        }
      }

      &_bot {
        bottom: -1px;
        height: 20px;
      }
    }

    &-sign {

      &-item {
        font-size: 13px;
        width: 212px;
        padding-top: 10px;
        border-top: 1px solid $color-mercury;

        &__input {
          font-size: 13px;
          width: 100%;
          margin: 0;
        }
      }
    }

    &-bottom {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      margin-bottom: 26px;

      &__button {
        width: 103px;
      }
    }

    &-footer {
      position: relative;
      padding-top: 20px;
      font-weight: normal;
      font-size: 11px;
      line-height: 13px;
      text-align: center;

      &:after {
        content: '';
        position: absolute;
        left: -35px;
        top: 0;
        height: 2px;
        width: calc(100% + 70px);
        background-color: $color-wild-sand;
      }
    }

    &_hide {
      &, * {
        font-family: 'Arial' !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/RefundHandovers/RefundHandoverForm/RefundHandoverForm.vue